// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KDOG","col":"styles_col__2Wn4a"};